import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteAllUsers as apiDeleteAllUsers } from "../../api/apiUsers";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useDeleteAllUsers() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const {
        mutate: deleteAllUsers,
        isPending: isDelete,
        data: results,
        error,
    } = useMutation({
        mutationFn: (req) => apiDeleteAllUsers(req),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["users"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { deleteAllUsers, isDelete, error, results };
}
